"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOM_FIELD_TYPE = void 0;
var CUSTOM_FIELD_TYPE;
(function (CUSTOM_FIELD_TYPE) {
    CUSTOM_FIELD_TYPE["INTEGER"] = "INTEGER";
    CUSTOM_FIELD_TYPE["DECIMAL"] = "DECIMAL";
    CUSTOM_FIELD_TYPE["TEXT"] = "TEXT";
    CUSTOM_FIELD_TYPE["BOOLEAN"] = "BOOLEAN";
    CUSTOM_FIELD_TYPE["SIGNATURE"] = "SIGNATURE";
    CUSTOM_FIELD_TYPE["PICTURE"] = "PICTURE";
    CUSTOM_FIELD_TYPE["GPS"] = "GPS";
    CUSTOM_FIELD_TYPE["SINGLE_CHOICE"] = "SINGLE_CHOICE";
    CUSTOM_FIELD_TYPE["MULTIPLE_CHOICE"] = "MULTIPLE_CHOICE";
    CUSTOM_FIELD_TYPE["PHONE_NUMBER"] = "PHONE_NUMBER";
    CUSTOM_FIELD_TYPE["BARCODE_SCANNER"] = "BARCODE_SCANNER";
    CUSTOM_FIELD_TYPE["SINGLE_CHOICE_ON_LIST"] = "SINGLE_CHOICE_ON_LIST";
    CUSTOM_FIELD_TYPE["MULTIPLE_INPUT_INTEGER"] = "MULTIPLE_INPUT_INTEGER";
    CUSTOM_FIELD_TYPE["MULTIPLE_INPUT_DECIMAL"] = "MULTIPLE_INPUT_DECIMAL";
    CUSTOM_FIELD_TYPE["MULTIPLE_INPUT_TEXT"] = "MULTIPLE_INPUT_TEXT";
    CUSTOM_FIELD_TYPE["MATRIX_ON_LIST"] = "MATRIX_ON_LIST";
    CUSTOM_FIELD_TYPE["TIME_PICKER"] = "TIME_PICKER";
    CUSTOM_FIELD_TYPE["DATE_PICKER"] = "DATE_PICKER";
    CUSTOM_FIELD_TYPE["PLAIN_TEXT"] = "PLAIN_TEXT";
    CUSTOM_FIELD_TYPE["MULTIPLE_CHOICE_ON_LIST"] = "MULTIPLE_CHOICE_ON_LIST";
    CUSTOM_FIELD_TYPE["COMPUTE"] = "COMPUTE";
    CUSTOM_FIELD_TYPE["RATING"] = "RATING";
    CUSTOM_FIELD_TYPE["UPLOAD_FILE"] = "UPLOAD_FILE";
    CUSTOM_FIELD_TYPE["GEO_DELIMITATION"] = "GEO_DELIMITATION";
    CUSTOM_FIELD_TYPE["JSON"] = "JSON";
})(CUSTOM_FIELD_TYPE || (exports.CUSTOM_FIELD_TYPE = CUSTOM_FIELD_TYPE = {}));
